module.exports = __webpack_public_path__ + "img/DP.d9d2e901.png";